import { useEffect, useState } from "react";
import Container from "@/components/Container";
import PropertyCard from "@/components/PropertyCard";
import { LogoMark } from "@/components/Logo";
import { api } from "@/lib/api";
import { PUBLIC } from "@/constants/testIds";

const FILTERS = [
  { key: "all", label: "All", testId: PUBLIC.filterAll },
  { key: "in_renovation", label: "In Renovation", testId: PUBLIC.filterRenovation },
  { key: "coming_soon", label: "Coming Soon", testId: PUBLIC.filterComing },
  { key: "completed", label: "Completed", testId: PUBLIC.filterCompleted },
  { key: "sold", label: "Sold", testId: PUBLIC.filterSold },
];

export default function Properties() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/public/properties${filter !== "all" ? `?status=${filter}` : ""}`)
      .then(r => setItems(r.data || [])).catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="pt-36 pb-32">
      <Container>
        <div className="flex items-center gap-4 mb-10">
          <span className="label-mono">No. 04 — Portfolio</span>
          <span className="h-px w-12 bg-ruby" />
        </div>
        <h1 className="serif-display text-5xl md:text-7xl lg:text-[8rem] text-ink-700">
          Properties of<br />
          <span className="serif-italic text-ruby">the house.</span>
        </h1>
        <p className="mt-10 text-ink-400 max-w-2xl text-lg leading-[1.7]">
          Every transformation, from quiet acquisition through editorial staging to sold under the Rubys.Group banner.
        </p>

        <div className="mt-20 border-t border-ink-700/15 pt-8 flex flex-wrap gap-3">
          {FILTERS.map(f => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              data-testid={f.testId}
              className={`px-5 py-2.5 text-[0.72rem] font-mono uppercase tracking-[0.15em] border transition-all ${
                filter === f.key
                  ? "border-ruby bg-ruby text-cream-100"
                  : "border-ink-700/20 text-ink-100 hover:border-ruby hover:text-ruby"
              }`}
            >{f.label}</button>
          ))}
        </div>

        <div className="mt-16">
          {loading ? (
            <p className="text-ink-100">Loading…</p>
          ) : items.length === 0 ? (
            <div className="surface-cream p-16 lg:p-24 text-center">
              <LogoMark size={56} className="text-ruby mx-auto" />
              <p className="label-mono mt-8">Curating the next chapter</p>
              <p className="serif-display text-3xl md:text-5xl text-ink-700 mt-6 max-w-xl mx-auto">
                Our next signature transformations will appear here.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-20">
              {items.map(p => <PropertyCard key={p.id} p={p} />)}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}
